var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-spin',{attrs:{"tip":"Loading..."}},[_c('div',{staticClass:"spin-content"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }